var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.9545 7.4698C2.00228 4.16272 4.71811 1.50293 8.05323 1.50293C10.2588 1.50293 12.192 2.66578 13.2629 4.40774C13.4075 4.64298 13.3341 4.95092 13.0988 5.09554C12.8636 5.24016 12.5556 5.1667 12.411 4.93146C11.5158 3.47523 9.89958 2.50293 8.05323 2.50293C5.26365 2.50293 3.00313 4.7214 2.95465 7.46838L3.22157 7.20355C3.4176 7.00905 3.73418 7.0103 3.92867 7.20632C4.12317 7.40235 4.12192 7.71893 3.92589 7.91342L2.80602 9.02454C2.61108 9.21795 2.29664 9.21795 2.1017 9.02454L0.981823 7.91343C0.785795 7.71893 0.784551 7.40235 0.979045 7.20632C1.17354 7.0103 1.49012 7.00905 1.68615 7.20355L1.9545 7.4698ZM13.1916 6.98065C13.3864 6.78813 13.6998 6.78813 13.8946 6.98065L15.0187 8.09176C15.2151 8.28588 15.217 8.60246 15.0229 8.79886C14.8287 8.99526 14.5122 8.9971 14.3158 8.80298L14.0425 8.53289C13.9962 11.8432 11.2684 14.5029 7.92231 14.5029C5.70984 14.5029 3.76986 13.3409 2.69478 11.5988C2.54976 11.3639 2.6227 11.0558 2.85769 10.9108C3.09269 10.7657 3.40076 10.8387 3.54578 11.0737C4.44438 12.5298 6.06731 13.5029 7.92231 13.5029C10.7265 13.5029 12.9954 11.281 13.0423 8.53421L12.7704 8.80298C12.574 8.9971 12.2574 8.99526 12.0633 8.79886C11.8692 8.60246 11.871 8.28588 12.0674 8.09176L13.1916 6.98065Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.e1b79f70885ca0696010c5273fd9bc96.svg";
export { ForwardRef as ReactComponent };